class Replace {
  constructor(element, attribute) {
      this.element = element;

      
      this.replaceID = document.querySelector(`[js-replace-id="${this.element.getAttribute(attribute)}"]`);
      if(this.replaceID) {
        this.replaceID.innerText = this.element.value;
        if(this.element.value == '1') this.replaceID.classList.add('is--one');
      }
  }
}

export default Replace;
